// Mid-fi palette (4019, UX-05) as hex values, for places Tailwind classes can't reach (Chart.js
// canvas, inline SVG). Mirrors the `mf-*` colors in src/tailwind.config.js; keep the two in sync.
export const MF = {
  bg: "#F3F4F6",
  card: "#FFFFFF",
  ink: "#25272E",
  sub: "#6B7280",
  faint: "#9AA1AC",
  border: "#E5E7EB",
  orange: "#F58220",
  orangeSoft: "#FEF0E2",
  orangeInk: "#B25E0B",
  energy: "#2FBF71",
  energyMd: "#8ED9B0",
  energySoft: "#E7F7EE",
  energyInk: "#1E8A52",
  slate: "#5B6478",
  slateSoft: "#E9EBF0",
  alert: "#D9534F",
  alertSoft: "#FBEAE9",
} as const;
